import { Whisper, Tooltip } from 'rsuite';

import { tremorBadgeStyle } from '../styles';
import { build_fault_string, isDeviceInFault, isDeviceOffline } from './Common';

// A coloured status pill with an optional hover tooltip. A plain <span> pill is
// used (not rsuite Tag) so the icon+label stay on one line — Tag nests children
// in an inner element that ignores the flex/nowrap layout. rsuite Whisper renders
// the tooltip in a portal on document.body, so it is NOT clipped by the
// overflow:hidden of an rsuite Table row (unlike the old Tremor Badge tooltip).
// tremorBadgeStyle() reproduces the pale-tint/dark-text look of the original
// Tremor <Badge> (the icon inherits the pill's text colour via currentColor).
const StatusBadge = ({ icon: Icon, color, tooltip, children }) => {
  const tag = (
    <span style={tremorBadgeStyle(color)}>
      {Icon ? <Icon style={{ flexShrink: 0 }} /> : null}
      <span>{children}</span>
    </span>
  );

  if (!tooltip) return tag;

  return (
    <Whisper trigger={['hover', 'focus']} placement="top" speaker={<Tooltip>{tooltip}</Tooltip>}>
      <span tabIndex={0} style={{ display: 'inline-flex' }}>
        {tag}
      </span>
    </Whisper>
  );
};

export const GetDeviceBadgeFromStatus = (device) => {
  return (
    <>
      {isDeviceOffline(device) ? (
        <StatusBadge icon={device.connStatIcon} color={device.connStatColor} tooltip={device.connStatDate}>
          {device.connStatDesc}
        </StatusBadge>
      ) : isDeviceInFault(device) ? (
        <StatusBadge
          icon={device.ctrlStatIcon}
          color={device.ctrlStatColor}
          tooltip={build_fault_string(device.currentFaults, true, 'Nil').string}
        >
          {device.ctrlStatDesc}
        </StatusBadge>
      ) : (
        !isDeviceInFault(device) &&
        !isDeviceOffline(device) && (
          <StatusBadge
            icon={device.connStatIcon}
            color={device.connStatColor}
            tooltip={device.connStatDate > device.ctrlStatDate ? device.connStatDate : device.ctrlStatDate}
          >
            GOOD
          </StatusBadge>
        )
      )}
    </>
  );
};
